(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("OrchardDataTables", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["OrchardDataTables"] = factory(require("react"), require("react-dom"));
	else
		root["OrchardDataTables"] = factory(root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 